import React, { useEffect, useState } from 'react'
import Header from '../../components/BugBounty/Header.js';
import TopBanner from '../../components/BugBounty/TopBannerComponent.js';
import ZeroToHeroSection from '../../components/BugBounty/ZeroToHeroComponent.js';
import BountyBanner from '../../components/BugBounty/BountyBanner.js';
import ToolsComponent from '../../components/BugBounty/ToolsComponent.js';
import ExerciseComponent from '../../components/BugBounty/ExercisesComponent.js';
import HackingCourses from '../../components/BugBounty/HackingCourses.js';
import PlansComponent from '../../components/BugBounty/PlansComponent.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import axios from 'axios';
import ENDPOINT from '../../data/ENDPOINT.js';
import SecurityHeaders from '../../data/SecurityHeaders.js';

const BountiesLab = () => {
    const [hackingMethods, setHackingMethods] = useState([])

    const getHackingMethods = async () => {
        try {
            const response = await axios.get(ENDPOINT + "get-hacking-methods.php", SecurityHeaders);
            if (response.data.status === 'success') {
                setHackingMethods(response.data.data);
            }

        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        getHackingMethods();
    }, [])

    return (
        <div className='darktheme hacking-lab pt-0 pt-md-4 '>
        
            <BountyBanner />
            <div class="d-flex container min-vh-100 mt-5 md-mt-4 flex-wrap animation-active">
                {hackingMethods ?
                    hackingMethods.map((item) => <ExerciseComponent key={item.id} item={item} index={item.id} />)
                    : <div class="text-center">Loading...</div>}
            </div>
            {/* <div class="d-flex justify-content-center my-5 align-items-center">
        <a href="/bug-bounty-lab" class="btn btn-success text-light rounded rounded-pill"> View All Hacking Exercises</a>

      </div> */}
            <div className="container">
                <hr></hr>

            </div>
            <div class=" p-3 pb-md-4 mx-auto text-center text-white animated-fade">
                <h1 class="display-4 fw-normal "><b>600+ Hacking Tools</b></h1>

                <h4><b>Learn Tools for every hacking operation</b></h4>
            </div>


            <ToolsComponent limit={4} />


            <div class="d-flex justify-content-center my-5 align-items-center animate-fade">
                <Link to="/hacking-tools" class="btn btn-success rounded rounded-pill"> View All Hacking Tools</Link>

            </div>
            <HackingCourses />
            {/* <PlansComponent /> */}

        </div>
    )
}

export default BountiesLab
